import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => window.scrollTo(0, 0),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/finalconference',
      name: 'hackathon',
      component: () => import(/* webpackChunkName: "hackathon" */ './views/Hackathon.vue')
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import(/* webpackChunkName: "partners" */ './views/Partners.vue')
    },
    {
      path: '/companies',
      name: 'companies',
      component: () => import(/* webpackChunkName: "companies" */ './views/Companies.vue')
    },
    {
      path: '/companies/:id',
      name: 'company',
      component: () => import(/* webpackChunkName: "company" */ './views/Company.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ './views/News.vue')
    },
    {
      path: '/news/:id',
      name: 'post',
      component: () => import(/* webpackChunkName: "post" */ './views/Post.vue')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import(/* webpackChunkName: "events" */ './views/Events.vue')
    },
    {
      path: '/events/:id',
      name: 'event',
      component: () => import(/* webpackChunkName: "event" */ './views/Event.vue')
    },
    {
      path: '/pages/:id',
      name: 'page',
      component: () => import(/* webpackChunkName: "page" */ './views/Page.vue')
    },
    {
      path: '/smart-map',
      name: 'smart-map',
      component: () => import(/* webpackChunkName: "smart-map" */ './views/SmartMap.vue')
    },
    {
      path: '/resources',
      name: 'resources',
      component: () => import(/* webpackChunkName: "resources" */ './views/Resources.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ './views/Register.vue')
    },
  ]
})
